"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HideAssetBodyToJSON = exports.HideAssetBodyFromJSONTyped = exports.HideAssetBodyFromJSON = void 0;
function HideAssetBodyFromJSON(json) {
    return HideAssetBodyFromJSONTyped(json, false);
}
exports.HideAssetBodyFromJSON = HideAssetBodyFromJSON;
function HideAssetBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'assetID': json['assetID'],
    };
}
exports.HideAssetBodyFromJSONTyped = HideAssetBodyFromJSONTyped;
function HideAssetBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'assetID': value.assetID,
    };
}
exports.HideAssetBodyToJSON = HideAssetBodyToJSON;
